export const isUserManagementAllowed = (userData): string => {
    return userData.isUserManagementAllowed;
};

export const isUserViewer = (userData): boolean => {
    return userData.isViewer;
};

export const isUserDepartmentManager = (userData): boolean => {
    return userData.isDepartmentManager;
};
